// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof process !== 'undefined' && process.versions != null && process.versions.node != null;

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.Home = (await import('./pages/Home')).Home;
    Components.PSHome = (await import('./pages/PSHome')).PSHome;
  }
  return Components;
};

export const getRoutes = (currentRouteName, currentRouteComponent, serverPages = {}) => ({
  home: {
    name: 'Home',
    componentName: 'Home',
    chunk: () => import(
      './pages/Home'
    ),
    get component() {
      return ssr
        ? serverPages.Home ?? generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })))
        : currentRouteName === 'Home'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })));
    },
    path: '/:context?/:id?/*',
    channel: null
  },
  pshome: {
    name: 'PSHome',
    componentName: 'PSHome',
    chunk: () => import(
      './pages/PSHome'
    ),
    get component() {
      return ssr
        ? serverPages.PSHome ?? generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.PSHome })))
        : currentRouteName === 'PSHome'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.PSHome })));
    },
    path: '/:context?/psdev',
    channel: null
  },
});
